import(/* webpackMode: "eager", webpackExports: ["HeaderEs"] */ "/vercel/path0/src/components/es/headerEs.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformAboutEs"] */ "/vercel/path0/src/components/es/platformAboutEs.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformHeroEs"] */ "/vercel/path0/src/components/es/platformHeroEs.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetCatalogEs"] */ "/vercel/path0/src/components/es/widgetCatalogEs.comp.tsx");
